<template>
  <div class="item-boxes--connected">
    <ItemBoxConnected
      v-for="item in items"
      :key="item.id"
      :link-url="item.linkUrl"
      :image-url="item.imageUrl"
      :brand-name="item.brandName"
      :item-name="item.itemName"
      :item-price="item.itemPrice"
      :is-including-tax="item.isIncludingTax"
      :has-multiple-item-skus="item.hasMultipleItemSkus"
      @click-item-box-connected="onClickItemBox(item.id)"
    />
  </div>
</template>
<script>
import ItemBoxConnected from '../../atoms/item_boxes/ItemBoxConnected.vue'
export default {
  components: { ItemBoxConnected },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickItemBox(itemId) {
      this.$emit('click-item-boxes-connected', itemId)
    }
  }
}
</script>
<style lang="scss" scoped>
.item-boxes--connected {
  text-align: left;
  justify-content: center;
  max-width: $max-contents-width;
  margin: 0 auto;
}
</style>
